import { createElementVNode as _createElementVNode, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/icons-img/camera.svg'


const _withScopeId = n => (_pushScopeId("data-v-50f74c54"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "list-wrapper"
}
const _hoisted_2 = { class: "chat-info" }
const _hoisted_3 = { class: "image-wrapper" }
const _hoisted_4 = {
  for: "img-uploader",
  class: "img-uploader"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "camera icon"
  })
], -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Make group public ")
const _hoisted_8 = { class: "bold mt-15" }
const _hoisted_9 = { class: "df search-wrapper" }
const _hoisted_10 = { class: "w-100" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_12 = {
  key: 1,
  class: "d-group-create"
}
const _hoisted_13 = { customTitle: "Create Group" }
const _hoisted_14 = { class: "chat-info" }
const _hoisted_15 = { class: "image-wrapper" }
const _hoisted_16 = {
  for: "img-uploader",
  class: "img-uploader"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "camera icon"
  })
], -1))
const _hoisted_19 = { class: "d-control-buttons" }
const _hoisted_20 = { class: "scroll" }
const _hoisted_21 = { class: "bold mt-15" }
const _hoisted_22 = { class: "df" }
const _hoisted_23 = { class: "w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_take_photo = _resolveComponent("app-take-photo")!
  const _component_app_input = _resolveComponent("app-input")!
  const _component_Form = _resolveComponent("Form")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_app_toggle = _resolveComponent("app-toggle")!
  const _component_app_search = _resolveComponent("app-search")!
  const _component_app_contact_item = _resolveComponent("app-contact-item")!
  const _component_app_item_wrapper = _resolveComponent("app-item-wrapper")!
  const _component_app_upload_info = _resolveComponent("app-upload-info")!
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_AppSkeletonDialog = _resolveComponent("AppSkeletonDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.mainStore.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_app_header, { customTitle: "Create Group" }, {
            bottom: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("label", _hoisted_4, [
                    _createElementVNode("img", {
                      class: "img",
                      src: _ctx.photoUrl
                    }, null, 8, _hoisted_5),
                    _hoisted_6
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: _ctx.fileInputKey,
                    onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.savePhoto && _ctx.savePhoto(...args))),
                    accept: "image/*",
                    id: "img-uploader",
                    class: "img-uploader",
                    type: "file",
                    ref: "fileInput"
                  }, null, 544)), [
                    [_vShow, false]
                  ])
                ]),
                (_openBlock(), _createBlock(_Teleport, { to: "#popup" }, [
                  _createVNode(_component_app_take_photo, {
                    image: _ctx.imageToCrop,
                    onOnCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.imageToCrop = {})),
                    onOnDone: _ctx.bufferCropImage,
                    singleUpload: "",
                    hideOptionsList: ""
                  }, null, 8, ["image", "onOnDone"])
                ])),
                _createVNode(_component_Form, {
                  class: "w-100",
                  as: "el-form",
                  "validation-schema": _ctx.schema,
                  onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_app_input, {
                      modelValue: _ctx.registrationGroupData.name,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.registrationGroupData.name) = $event)),
                      name: "groupName",
                      label: _ctx.$localize('group.chat.create.group_name'),
                      placeholder: _ctx.$localize('group.chat.create.add.group.name'),
                      onInput: _ctx.validate,
                      propError: _ctx.errorMessage
                    }, null, 8, ["modelValue", "label", "placeholder", "onInput", "propError"])
                  ]),
                  _: 1
                }, 8, ["validation-schema"])
              ])
            ]),
            "top-left": _withCtx(() => [
              _createElementVNode("a", {
                href: "javascript:void(0);",
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["prevent"])),
                class: "back-link"
              }, _toDisplayString(_ctx.$localize('group.chat.create.cancel')), 1)
            ]),
            "top-right": _withCtx(() => [
              _createElementVNode("a", {
                href: "javascript:void(0);",
                onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createGroup && _ctx.createGroup(...args)), ["prevent"])),
                class: _normalizeClass(["back-link", { disabled: !_ctx.isValid }])
              }, _toDisplayString(_ctx.$localize('group.chat.create.done')), 3)
            ]),
            _: 1
          }),
          _createElementVNode("div", {
            class: "scroll",
            ref: "scroller",
            onScroll: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
          }, [
            _createVNode(_component_app_toggle, {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isGroupPublic = !_ctx.isGroupPublic)),
              checked: _ctx.isGroupPublic,
              id: "public-toggle"
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["checked"]),
            _createElementVNode("h5", _hoisted_8, _toDisplayString(_ctx.$localize('group.chat.create.add.members')), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_app_search, {
                  modelValue: _ctx.driveStore.search,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.driveStore.search) = $event)),
                  onClear: _cache[8] || (_cache[8] = ($event: any) => (_ctx.driveStore.search = ''))
                }, null, 8, ["modelValue"])
              ])
            ]),
            (!_ctx.driveStore.search)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.filteredContacts.length)
                    ? (_openBlock(), _createBlock(_component_app_item_wrapper, { key: 0 }, {
                        title: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$localize('contacts.my.contacts')), 1)
                        ]),
                        main: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredContacts, (contact) => {
                            return (_openBlock(), _createBlock(_component_app_contact_item, {
                              key: contact.accountId,
                              contact: contact,
                              "invited-user-ids": _ctx.invitedUserIds,
                              onInviteToGroup: _ctx.inviteToGroup
                            }, null, 8, ["contact", "invited-user-ids", "onInviteToGroup"]))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.myContactsSearch.length)
                    ? (_openBlock(), _createBlock(_component_app_item_wrapper, { key: 0 }, {
                        title: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$localize('contacts.my.contacts')), 1)
                        ]),
                        main: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myContactsSearch, (contact) => {
                            return (_openBlock(), _createBlock(_component_app_contact_item, {
                              key: contact.accountId,
                              contact: contact,
                              "invited-user-ids": _ctx.invitedUserIds,
                              onInviteToGroup: _ctx.inviteToGroup
                            }, null, 8, ["contact", "invited-user-ids", "onInviteToGroup"]))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.notMyContactsSearch.length)
                    ? (_openBlock(), _createBlock(_component_app_item_wrapper, { key: 1 }, {
                        title: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$localize('contacts.my.other')), 1)
                        ]),
                        main: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notMyContactsSearch, (contact) => {
                            return (_openBlock(), _createBlock(_component_app_contact_item, {
                              key: contact.accountId,
                              contact: contact,
                              "invited-user-ids": _ctx.invitedUserIds,
                              onInviteToGroup: _ctx.inviteToGroup
                            }, null, 8, ["contact", "invited-user-ids", "onInviteToGroup"]))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _hoisted_11
                ], 64)),
            (_ctx.isUploading)
              ? (_openBlock(), _createBlock(_component_app_loader, {
                  key: 2,
                  message: _ctx.loaderText
                }, {
                  default: _withCtx(() => [
                    (_ctx.isUploading && _ctx.uploadInfo.total)
                      ? (_openBlock(), _createBlock(_component_app_upload_info, {
                          key: 0,
                          "upload-info": _ctx.uploadInfo,
                          onCancelUpload: _ctx.cancelUpload
                        }, null, 8, ["upload-info", "onCancelUpload"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["message"]))
              : _createCommentVNode("", true),
            (!!_ctx.loader)
              ? (_openBlock(), _createBlock(_component_AppSkeletonDialog, {
                  key: 3,
                  title: _ctx.registrationGroupData.name,
                  group: "",
                  hideSkeletons: ""
                }, null, 8, ["title"]))
              : _createCommentVNode("", true)
          ], 544)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.mainStore.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, [
                  _createElementVNode("img", {
                    class: "img",
                    src: _ctx.photoUrl
                  }, null, 8, _hoisted_17),
                  _hoisted_18
                ]),
                _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: _ctx.fileInputKey,
                  onInput: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.savePhoto && _ctx.savePhoto(...args))),
                  accept: "image/*",
                  id: "img-uploader",
                  class: "img-uploader",
                  type: "file",
                  ref: "fileInput"
                }, null, 544)), [
                  [_vShow, false]
                ])
              ]),
              (_openBlock(), _createBlock(_Teleport, { to: "#popup" }, [
                _createVNode(_component_app_take_photo, {
                  image: _ctx.imageToCrop,
                  onOnCancel: _cache[11] || (_cache[11] = ($event: any) => (_ctx.imageToCrop = {})),
                  onOnDone: _ctx.bufferCropImage,
                  singleUpload: "",
                  hideOptionsList: ""
                }, null, 8, ["image", "onOnDone"])
              ])),
              _createVNode(_component_Form, {
                class: "w-100",
                as: "el-form",
                "validation-schema": _ctx.schema
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_app_input, {
                    modelValue: _ctx.registrationGroupData.name,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.registrationGroupData.name) = $event)),
                    name: "groupName",
                    label: _ctx.$localize('group.chat.create.group_name'),
                    placeholder: _ctx.$localize('group.chat.create.add.group.name'),
                    onInput: _ctx.validate,
                    propError: _ctx.errorMessage
                  }, null, 8, ["modelValue", "label", "placeholder", "onInput", "propError"])
                ]),
                _: 1
              }, 8, ["validation-schema"])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("a", {
              href: "javascript:void(0);",
              onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["prevent"])),
              class: "back-link"
            }, _toDisplayString(_ctx.$localize('group.chat.create.cancel')), 1),
            _createElementVNode("a", {
              href: "javascript:void(0);",
              onClick: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createGroup && _ctx.createGroup(...args)), ["prevent"])),
              class: _normalizeClass(["back-link", { disabled: !_ctx.isValid }])
            }, _toDisplayString(_ctx.$localize('group.chat.create.done')), 3)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("h5", _hoisted_21, _toDisplayString(_ctx.$localize('group.chat.create.add.members')), 1),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_app_search, {
            modelValue: _ctx.driveStore.search,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.driveStore.search) = $event)),
            onClear: _cache[16] || (_cache[16] = ($event: any) => (_ctx.driveStore.search = ''))
          }, null, 8, ["modelValue"])
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredContacts, (contact) => {
        return (_openBlock(), _createElementBlock("div", {
          key: contact.accountId
        }, [
          _createVNode(_component_app_contact_item, {
            contact: contact,
            "invited-user-ids": _ctx.invitedUserIds,
            onInviteToGroup: _ctx.inviteToGroup
          }, null, 8, ["contact", "invited-user-ids", "onInviteToGroup"])
        ]))
      }), 128)),
      (_ctx.isUploading)
        ? (_openBlock(), _createBlock(_component_app_loader, {
            key: 0,
            message: _ctx.loaderText
          }, {
            default: _withCtx(() => [
              (_ctx.isUploading && _ctx.uploadInfo.total)
                ? (_openBlock(), _createBlock(_component_app_upload_info, {
                    key: 0,
                    "upload-info": _ctx.uploadInfo,
                    onCancelUpload: _ctx.cancelUpload
                  }, null, 8, ["upload-info", "onCancelUpload"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["message"]))
        : _createCommentVNode("", true),
      (!!_ctx.loader)
        ? (_openBlock(), _createBlock(_component_AppSkeletonDialog, {
            key: 1,
            title: _ctx.registrationGroupData.name,
            group: "",
            hideSkeletons: ""
          }, null, 8, ["title"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}